// extracted by mini-css-extract-plugin
module.exports = {"connectivity":"CellConnectivity_connectivity__FCzkT","row":"CellConnectivity_row__GA_xd","tableRow":"CellConnectivity_tableRow__vIpQO"};